<template>
  <div style="width:100%;height:100%;">
    <div id="tips">Guide
      <div id="tip-panel">
        1. A blue scatter represents a firm, while a brown one represents a Confucian temple.<br>
        2. When your mouse hovers over a scatter, you can see more detailed information on it.<br> 3. Please use the
        buttons at the top-right corner to handle the scatters. <br>
        4. Please use the mouse wheel to zoom the map.
      </div>
    </div>
    <div id="dataMapecharts">

    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import china from "../assets/data/china.json";
import firms from '../assets/data/firms.json'
import temples from '../assets/data/temples.json'
export default {
  name: 'MyMap',
  data() {
    return {
      firmShow: true,
      templeShow: false,


    };
  },
  mounted() {
    this.mYecharts();
    const guideElem = document.getElementById('tips')
    guideElem.onmouseover = () => {
      const guidePanelElem = document.getElementById('tip-panel')
      guidePanelElem.style.display = 'block'
    }
    guideElem.onmouseout = () => {
      const guidePanelElem = document.getElementById('tip-panel')
      guidePanelElem.style.display = 'none'
    }
  },
  methods: {
    mYecharts() {
      const that = this
      echarts.registerMap("china", china, {});
      //加载中国地图
      var myChart = echarts.init(
        document.getElementById("dataMapecharts")
      );
      // 绘制图表
      var chinaMap = {
        title: {
          //标题
          text: "The distribution of Confucian temples in China",
          left: "center",
          top: 20,
        },
        zoom: 5,
        tooltip: {
          //鼠标移动到某个省份时显示内容
          show: true,
          formatter: function (item) {
            let resData = item.data;
            // console.log(item, resData);
            if (resData) {
              return "Province: " + resData.name + "<br/>" + "The number of Confucian temples: " + resData.value;
            }
          },
        },
        selectedMode: "single",
        geo: {
          // 设置地图的显示信息
          map: "china", // 注意  哪个区域的就显示哪个区域的名称
          label: {
            show: true,
            normal: {
              show: true,
              textStyle: {
                color: "rgba(0,0,0,0)",
                fontSize: 12,
              },
            },
            emphasis: {
              textStyle: {
                color: "rgba(0,0,0,0)",
              },
              show: true,
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              borderColor: "#ccc",
              areaColor: "#e0f3f8",
              borderWidth: 1,
            },
            emphasis: {
              areaColor: "#9DD4F4",
              shadowColor: "rgba(0, 0, 0, 0.5)",
              borderWidth: 1,
            },
          },
          //   left: "5%",
          //   right: "5%",
          //   top: "5%",
          //   bottom: "5%",
        },
        series: [
          {
            type: "map",
            geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
            data: [
              { name: "Beijing", selected: false, value: 7 },
              { name: "Tianjing", selected: false, value: 2 },
              { name: "Shanghai", selected: false, value: 4 },
              { name: "Chongqing", selected: false, value: 2 },
              { name: "Hebei", selected: false, value: 19 },
              { name: "Henan", selected: false, value: 58 },
              { name: "Yunnan", selected: false, value: 45 },
              { name: "Liaoning", selected: false, value: 5 },
              { name: "Heilongjiang", selected: false, value: 3 },
              { name: "Hunan", selected: false, value: 25 },
              { name: "Anhui", selected: false, value: 17 },
              { name: "Shandong", selected: false, value: 18 },
              { name: "Xinjiang", selected: false, value: 1 },
              { name: "Jiangsu", selected: false, value: 17 },
              { name: "Zhejiang", selected: false, value: 17 },
              { name: "Jiangxi", selected: false, value: 14 },
              { name: "Hubei", selected: false, value: 17 },
              { name: "Guangxi", selected: false, value: 9 },
              { name: "Gansu", selected: false, value: 18 },
              { name: "Shanxi", selected: false, value: 39 },
              { name: "Inner Mongoria", selected: false, value: 0 },
              { name: "Shaanxi", selected: false, value: 41 },
              { name: "Jilin", selected: false, value: 2 },
              { name: "Fujian", selected: false, value: 23 },
              { name: "Guizhou", selected: false, value: 12 },
              { name: "Guangdong", selected: false, value: 31 },
              { name: "Qinghai", selected: false, value: 2 },
              { name: "Tibet", selected: false, value: 0 },
              { name: "Sichuan", selected: false, value: 37 },
              { name: "Ningxia", selected: false, value: 0 },
              { name: "Hainan", selected: false, value: 6 },
              { name: "Taiwan", selected: false, value: 0 },
              { name: "Hong Kong", selected: false, value: 0 },
              { name: "Macao", selected: false, value: 0 },
            ],
          },
          {
            type: 'effectScatter',  // 散点图类型
            coordinateSystem: 'geo',  // 使用地理坐标系
            geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
            data: firms,
            symbolSize: 4,  // 散点的大小
            effectType: "ripple",        //特效类型，目前只支持涟漪特效'ripple'。
            showEffectOn: "hover",
            rippleEffect: {              //涟漪特效相关配置。
              period: 4,               //动画的时间。
              scale: 8,              //动画中波纹的最大缩放比例。
              brushType: 'fill',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
            },

            itemStyle: {
              normal: {
                color: 'rgb(128,114,226)',  // 散点的颜色
                show: true,
              }
            },
            tooltip: {
              //鼠标移动到某个省份时显示内容
              show: true,
              formatter: function (item) {
                let resData = item.data;
                // console.log(item, resData);
                if (resData) {
                  return `Confucian temples within 50km: ${resData[2]}<br>
                  Confucian temples within 100km: ${resData[3]}<br>
                  Confucian temples within 200km: ${resData[4]}<br>
                  Confucian temples within 300km: ${resData[5]}`;
                }
              },
            },

          },
          {
            type: 'scatter',  // 散点图类型
            coordinateSystem: 'geo',  // 使用地理坐标系
            geoIndex: 0, // 不可缺少，否则无tooltip 指示效果
            data: [],
            symbolSize: 4,  // 散点的大小
            effectType: "ripple",        //特效类型，目前只支持涟漪特效'ripple'。
            showEffectOn: "hover",
            rippleEffect: {              //涟漪特效相关配置。
              period: 4,               //动画的时间。
              scale: 8,              //动画中波纹的最大缩放比例。
              brushType: 'fill',      //波纹的绘制方式，可选 'stroke' 和 'fill'。
            },
            itemStyle: {
              normal: {
                color: 'rgb(128,128,0)',  // 散点的颜色
                show: true,
              }
            },
            tooltip: {
              //鼠标移动到某个省份时显示内容
              show: true,
              formatter: function (item) {
                let resData = item.data;
                // console.log(item, resData);
                if (resData) {
                  return `Temple`;
                }
              },
            },

          }
        ],
        dataRange: {//左下角的颜色块。start：值域开始值；end：值域结束值；label：图例名称；color：自定义颜色值
          x: 'left',
          y: 'bottom',
          seriesIndex: "0",
          splitList: [
            { start: 51, label: '> 50', color: 'rgb(236,118,50)' },
            { start: 41, end: 50, label: '41 - 50', color: 'rgb(236,138,85)' },
            { start: 31, end: 40, label: '31 - 40', color: 'rgb(239,155,111)' },
            { start: 21, end: 30, label: '21 - 30', color: 'rgb(245,195,172)' },
            { start: 11, end: 20, label: '11 - 20', color: 'rgb(245,225,214)' },
            { start: 0, end: 10, label: '0 - 10', color: 'rgb(250,237,228)' }
          ],

        },
        toolbox: {
          top: 17,
          right: 10,
          feature: {
            myTool1: {
              show: true,
              title: 'Enlarge the scatters',
              icon: 'path://M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895',
              onclick: function () {
                const option = myChart.getOption();
                option.series[1].symbolSize += 1;
                option.series[2].symbolSize += 1;
                myChart.setOption(option);
              }
            },
            myTool2: {
              show: true,
              title: 'Shrink the scatters',
              icon: 'path://M877.4 528.2H148.7c-10.5 0-19.1-8.6-19.1-19.1s8.6-19.1 19.1-19.1h728.7c10.5 0 19.1 8.6 19.1 19.1s-8.5 19.1-19.1 19.1',
              onclick: function () {
                const option = myChart.getOption();
                option.series[1].symbolSize -= 1;
                option.series[2].symbolSize -= 1;
                myChart.setOption(option);
              }
            },
            myTool3: {
              show: true,
              title: 'Show/Hide firms',
              icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
              onclick: function () {
                that.firmShow = !that.firmShow
                const option = myChart.getOption();
                option.series[1].data = that.firmShow ? firms : [];
                myChart.setOption(option);
              }
            },
            myTool4: {
              show: true,
              title: 'Show/Hide temples',
              icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
              onclick: function () {
                that.templeShow = !that.templeShow
                const option = myChart.getOption();
                option.series[2].data = that.templeShow ? temples : [];
                myChart.setOption(option);

              }
            }
          }
        }
        //各省地图颜色；start：值域开始值；end：值域结束值；label：图例名称；color：自定义颜色值；名字与json对应，（start: 1,  end: 1）是data数组的key值
      };

      myChart.on("click", function (param) {
        //地图省份点击事件
        console.log(param, param.name);
      });

      myChart.on("geoRoam", function () {
        var option = myChart.getOption();//获得option对象
        // if(params.zoom!=null&&params.zoom!=undefined){ //捕捉到缩放时
        // option.geo[1].zoom=option.geo[0].zoom;//下层geo的缩放等级跟着上层的geo一起改变
        // option.geo[1].center=option.geo[0].center;//下层的geo的中心位置随着上层geo一起改变
        // myChart.clear();
        // } else {//捕捉到拖曳时
        // myChart.clear();
        // option.geo[1].center=option.geo[0].center;//下层的geo的中心位置随着上层geo一起改变
        // }
        myChart.setOption(option, true);
      });
      myChart.setOption(chinaMap);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dataMapecharts {
  width: 100%;
  height: 100%;
  background: rgb(200, 200, 200);
}

#tips {
  position: fixed;
  top: 24px;
  left: 15px;
  z-index: 100;
  text-decoration: underline;
  cursor: pointer;
}

#tip-panel {
  display: none;
  position: absolute;
  top: 20px;
  left: 0px;
  background: white;
  padding: 15px 10px 15px 20px;
  border-radius: 8px;
  min-width: 250px;
  text-align: left;
  line-height: 25px;
  cursor: text;
}
</style>
